if (!customElements.get('share-buttons')) {
  class ShareButtons extends HTMLElement {
    constructor() {
      super();
      this._controller = new AbortController();
      this.handleCopy = this.handleCopy.bind(this);
      this.handleNativeShare = this.handleNativeShare.bind(this);
    }

    connectedCallback() {
      const { signal } = this._controller;

      this.copyBtn = this.querySelector('.share-buttons__copy');
      this.nativeBtn = this.querySelector('.share-buttons__native');
      this.nativeItem = this.querySelector('.share-buttons__item--native');
      this.statusEl = this.querySelector('[role="status"]');

      this.copyBtn?.addEventListener('click', this.handleCopy, { signal });

      if (navigator.share) {
        this.nativeItem?.removeAttribute('hidden');
        this.nativeBtn?.addEventListener('click', this.handleNativeShare, { signal });
      }
    }

    disconnectedCallback() {
      this._controller.abort();
      clearTimeout(this._copyResetTimeout);
    }

    get shareUrl() {
      return this.dataset.url;
    }

    get shareTitle() {
      return this.dataset.title;
    }

    get successMessage() {
      return this.dataset.success;
    }

    async handleCopy() {
      try {
        await navigator.clipboard.writeText(this.shareUrl);
        this.showCopySuccess();
      } catch {
        this.fallbackCopy();
      }
    }

    fallbackCopy() {
      const input = document.createElement('input');
      input.value = this.shareUrl;
      input.style.position = 'absolute';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.showCopySuccess();
    }

    showCopySuccess() {
      if (!this.copyBtn) return;
      const label = this.copyBtn.querySelector('.share-buttons__copy-text');
      const original = label?.textContent;

      if (label) label.textContent = this.successMessage;
      if (this.statusEl) this.statusEl.textContent = this.successMessage;
      this.copyBtn.classList.add('share-buttons__copy--success');

      clearTimeout(this._copyResetTimeout);
      this._copyResetTimeout = setTimeout(() => {
        if (label) label.textContent = original;
        if (this.statusEl) this.statusEl.textContent = '';
        this.copyBtn.classList.remove('share-buttons__copy--success');
      }, 2500);
    }

    async handleNativeShare() {
      try {
        await navigator.share({ title: this.shareTitle, url: this.shareUrl });
      } catch (err) {
        if (err.name !== 'AbortError') console.error(err);
      }
    }
  }

  customElements.define('share-buttons', ShareButtons);
}
